import React from 'react';

import { Container } from './styles';

export default function Dashboard() {
  return (
    <Container>
      <h1>Em breve ;)</h1>
      <br />
      <h2>Versão web em desenvolvimento</h2>
      <h2>Por enquanto acesse pelo nosso App!</h2>
    </Container>
  );
}
